import "./App.css";
import "./SolarGikLib/TextStyles.css";

import { PersistGate } from "reduxjs-toolkit-persist/lib/integration/react";
import { persistor } from "./features/app/Store";
import SudoModeListener from "./features/user/SudoModeListener";
import InitApp from "./pages/InitApp";
import PageRoutes, { AuthenticatedPageRoutes } from "./pages/PageRoutes";
import TagsPoller from "./pages/TagsPoller";
import getIcons from "./SolarGikLib/icons/Icons";
import { GeneralIcons, IconCategory } from "./SolarGikLib/icons/IconsModels";
import { SgStylingProvider } from "./common/Mui/SgStylingThemeProvider";
import IssuesPoller from "./pages/IssuesPoller";
import { BackdropPortalAnchorElementId } from "./SolarGikLib/backdrop/SgBackdrop";
import ApplicationSessionBoundary from "./features/auth/ApplicationSessionBoundary";

const AuthenticatedApp = () => {
  const SolargikIcon = getIcons(GeneralIcons.SolarGikLogo, IconCategory.General);

  return (
    <SgStylingProvider>
      <div className="App">
        <PersistGate loading={null} persistor={persistor}>
          <ApplicationSessionBoundary>
            <SudoModeListener />
            <InitApp
              loadingIcon={
                <div className="third-height">
                  <SolargikIcon fontSize={"large"} />
                </div>
              }
            >
              <AuthenticatedPageRoutes />
              <TagsPoller />
              <IssuesPoller />
              <div id={BackdropPortalAnchorElementId}></div>
            </InitApp>
          </ApplicationSessionBoundary>
        </PersistGate>
      </div>
    </SgStylingProvider>
  );
};

const App = () => <PageRoutes protectedContent={<AuthenticatedApp />} />;

export default App;
